

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FireFileService {

  constructor(
    private http: HttpClient
  ) { }  
  
  public SaveFileFirebaseCartillas(model) {
    return this.http.post(`${environment.api.WS_QM.url}/FireFileManager/SaveFileFirebaseCartillas`,model)
      .pipe(map(response => response));
  }
  public SaveFileFirebaseGeneral(model) {
    return this.http.post(`${environment.api.WS_QM.url}/FireFileManager/SaveFileFirebaseGeneral`,model)
      .pipe(map(response => response));
  }
  
}
